const { createSlice } = require("@reduxjs/toolkit");

const initialState = {
  loading: false,
  toasterMessage: "Somthing went wrong!",
  messageToaster: false,
  toasterType: "error",

  userId: null,
};

export const AlertMessageSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    showNotification: (state, action) => {
      // Make sure action.payload exists before updating state
      if (action.payload) {
        console.log(
          "Alert message activity notification slice",
          action.payload,
        );
        // state.loading = action.payload.loading || state.loading;
        state.toasterMessage = action.payload.toasterMessage || "";
        state.messageToaster = action.payload.messageToaster || false;
        state.toasterType = action.payload.toasterType || "";
      }
    },
    clearNotifcation: (state, action) => {
      // Make sure action.payload exists before updating state
      console.log("Alert message activity slice", action.payload);
      state.loading = action?.payload?.loading || false;
      state.toasterMessage = action?.payload?.toasterMessage || "Somthing went wrong!";
      state.messageToaster = action?.payload?.messageToaster || false;
      state.toasterType = action?.payload?.toasterType || "error";
    },
    setUserId: (state, action) => {
      state.userId = action.payload;
    },
  },
});

export const {
  showNotification,
  clearNotifcation,
  setUserId,
} = AlertMessageSlice.actions;
export default AlertMessageSlice.reducer;
